// Libs
import classNames from 'classnames/bind';
import { Grid2, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { IFormClient } from '~/utils/interface/client';
import { TypeCrmEnum } from '~/utils/enum/common';
import { formatPhoneNumber } from '~/utils/helper/common';
// Styles, images, icons
import styles from './ContactInfoClientForm.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ContactInfoClientForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/client', 'common/base']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IFormClient>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='contactInfoClientFormComponent' gap={'14px'}>
      <Grid2 container columnSpacing={5} rowSpacing={3}>
        <Grid2 size={6}>
          <Controller
            control={control}
            name={`clientContacts.0.email`}
            render={({ field: { onChange, value } }) => {
              return (
                <BaseInput
                  height={36}
                  label={t('client_form_title_primary_email')}
                  value={value}
                  onChange={onChange}
                  errorMessage={errors?.clientContacts?.[0]?.email?.message}
                />
              );
            }}
          />
        </Grid2>

        <Grid2 size={6}>
          <Controller
            control={control}
            name={`clientContacts.0.phoneNumber`}
            render={({ field: { onChange, value } }) => {
              return (
                <BaseInput
                  height={36}
                  label={t('client_form_title_primary_phone')}
                  value={value}
                  onChange={(event) => {
                    onChange(formatPhoneNumber(event.target.value));
                  }}
                  errorMessage={errors?.clientContacts?.[0]?.phoneNumber?.message}
                />
              );
            }}
          />
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default ContactInfoClientForm;
